import { enableProdMode, importProvidersFrom } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MAT_DIALOG_DEFAULT_OPTIONS, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RedirectGuard } from './app/guards/redirect.guard';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { EcaComponentsLibModule } from '@drc-eca/eca-components-lib';
import { environment } from './environments/environment';

import { AppComponent } from './app/app.component';
import { appRoutes } from './app/app-routing/app-routing.module';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideRouter(appRoutes),
    provideAnimations(),
    importProvidersFrom(EcaComponentsLibModule.forRoot(environment.apiGatewayConfig)),
    { provide: 'api-gateway-config', useValue: environment.apiGatewayConfig },
    { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
    RedirectGuard,
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: {} },
    provideHttpClient(withInterceptorsFromDi()),
  ]
})
  .catch(err => console.log(err));
